module.exports = __webpack_public_path__ + "img/10.e1ae57ef.png";